/**
 * Category slider – Swiper se slidesPerView: 'auto'.
 *
 * Šířky slidů určuje CSS (viz #category-swiper .swiper-slide), slider je
 * responzivní automaticky – zobrazí tolik auto-šířkových slidů, kolik se vejde,
 * zbytek "peekuje" za okraj (SCSS: overflow: visible). Swiper je globál
 * z vendor bundle (swiper-bundle.min.js).
 */
function initCategorySlider() {
    const el = document.getElementById('category-swiper');
    if (!el || typeof Swiper === 'undefined') return;

    new Swiper(el, {
        slidesPerView: 'auto',
        spaceBetween: 16,
        grabCursor: true,
        mousewheel: {
            forceToAxis: true, // jen vodorovné gesto (2 prsty doleva/doprava na trackpadu)
        },
        pagination: {
            el: '.swiper-pagination-category',
            clickable: true,
        },
        breakpoints: {
            820: { spaceBetween: 24 },
            1280: { spaceBetween: 30 },
        },
    });
}

document.addEventListener('DOMContentLoaded', initCategorySlider);
